<div class="loader-overlay">
  <mat-spinner></mat-spinner>
  <p class="content">{{ content | transloco }}</p>
</div>
